/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, EMPTY, tap } from 'rxjs';
import { GroupsService } from '../../../../services/api/groups/groups.service';
import { UserService } from '../../../../services/api/user/user.service';
import { BasePopupComponent } from '../base-popup/base-popup.component';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';

@Component({
    selector: 'app-share-profile-popup',
    standalone: false,
    templateUrl: './share-profile-popup.component.html',
    styleUrl: './share-profile-popup.component.scss',
})
export class ShareProfilePopupComponent extends BasePopupComponent implements OnInit {
    protected profileLink = signal<string>('');
    constructor(
        @Inject(MAT_DIALOG_DATA) protected override data: any,
        @Inject(PLATFORM_ID) private platformId: object,
        protected override dialogRef: MatDialogRef<ShareProfilePopupComponent>,
        private dialog: MatDialog,
        private groupsService: GroupsService,
        private matSnackBar: MatSnackBar,
        private userService: UserService,
    ) {
        super(data, dialogRef);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        if (!this.data.isGroup) {
            this.generateProfileLink();
        } else {
            this.generateGroupLink();
        }
    }

    protected copyLink(): void {
        if (!isPlatformBrowser(this.platformId) || !this.profileLink) {
            return;
        }

        if (navigator && navigator.clipboard) {
            navigator.clipboard
                .writeText(this.profileLink())
                .then(() => {
                    this.matSnackBar.open('Copied to clipboard.', '', { duration: 2000 });
                })
                .catch(() => {
                    this.matSnackBar.open('Failed to copy link.', '', { duration: 2000 });
                });
        } else {
            const tempInput = document.createElement('input');
            tempInput.value = this.profileLink();
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            this.matSnackBar.open('Copied to clipboard.', '', { duration: 2000 });
        }
    }

    private generateProfileLink(): void {
        this.userService
            .generateShareUserLink(this.data.id)
            .pipe(
                tap((response) => {
                    this.profileLink.set(response.url);
                }),
                catchError((error) => {
                    const errorPopupConfig = SuccessPopupComponent.getDialogConfig();
                    errorPopupConfig.data = {
                        title: `Error`,
                        message: error.error?.message,
                    };
                    this.dialog.open(SuccessPopupComponent, errorPopupConfig);
                    console.error('Error generating shareable profile link:', error);
                    return EMPTY;
                }),
            )
            .subscribe();
    }

    private generateGroupLink(): void {
        this.groupsService
            .generateShareGroupLink(this.data.group.id)
            .pipe(
                tap((response) => {
                    this.profileLink.set(response.url);
                }),
                catchError((error) => {
                    const errorPopupConfig = SuccessPopupComponent.getDialogConfig();
                    errorPopupConfig.data = {
                        title: `Error`,
                        message: error.error?.message,
                    };
                    this.dialog.open(SuccessPopupComponent, errorPopupConfig);
                    console.error('Error generating shareable group link:', error);
                    return EMPTY;
                }),
            )
            .subscribe();
    }
}
